import React, {useState, useEffect, Fragment, useContext} from "react";
import Layout from "components/sales/layout/layout";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import { toast } from "react-toastify";
import useLatLng from "../../../../../hooks/uselatlng/uselatlng";
import FileUpload from "../../../../../components/sales/fileUpload/fileUpload";
import {Button} from "react-bootstrap";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import './raise_payment.css'

const PaymentRaise = ({
                          match,
                          history,
                          documentUploadUrlPublic,
                          documentUrlDataPublic,
                          bankListResponse = [],
                          bankListRequest,
                          loanUndertakingRequest,
                          loanAccountRequest,
                          loanPaymentRaiseRequest,
                          loanApplicationUpdateResponse = [],
                          loanAccountResponse = [],
                          loanTranchesRequest,
                          loanTranchesResponse = [],
                          loanPaymentRaiseUpdateRequest,
                          loanApplicationByIdRequest,
                          ucdCaseByIdResponse = [],
                          loanPaymentRaiseResponse = [],
                          loanPaymentRaiseUpdateResponse = [],
                          loanApprovalRequestRequest,
                          loanApprovalRequestResponse = []
                        }) => {
    const { baseUrl } = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const [inputList, setInputList] = useState([{
        payment_details: {
            existing_loan: '',
            for_closure_amount: '',
            fc_closure_amount_proof: '',
            prev_loan_closure: '',
            mode_of_payment: '',
            loan_amount_from_bank: '',
            utr_no: '',
            loan_closure_payment_proof: '',
            disbursal_date: '',
            disbursal_memo: '',
        },
        dealer_details: {
            account_number: '',
            bank_name: '',
            ifsc_code: '',
            branch_name: '',
        },
        hold_back_Details: {
            amount_approval_proof: '',
            amount: '',
            account_id: '',
            mode_of_payment: '',
            remark: '',
        },
        undertaking:{
            undertaking:''
        }
    }]);

    const [otherBankName, setBankName]  = useState(true);
    const [stage, setStage] = useState(1);
    const [tranches, setTranches] = useState([{amount: '', account_id: '', payment_mode: '', remark: ''}])
    const [changeAmount, setAmountChanged] = useState(0);
    const [bankAmountLoanReceived, setBankAmountLoanReceived] = useState([{loan_amount_from_bank: '', utr_no: ''}])
    const [checkDisbursalMemo, setCheckDisbursalMemo] = useState(false);
    const [amountReceived, setAmountReceived] = useState(0)

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await bankListRequest()
            await loanAccountRequest(match?.params?.id)
            await loanTranchesRequest(match?.params?.id)
            await loanApplicationByIdRequest(match?.params?.id)
            setIsLoading(false)
        })()
    }, [])

    const handleInput = (val, index, e = '', key = '') => {
        const list = [...inputList]
        list[0][key][index] = '';
        list[0][key][index] = val
        setInputList(list)
    }


    const handleSubmit = async (e) => {
        e.preventDefault()
        if(stage < 5){
            return false;
        }

        let requestParams = inputList[0];
        if(stage < 5){
            return false;
        }
        if(!requestParams['payment_details']['existing_loan']){
            requestParams['payment_details']['existing_loan'] = ucdCaseByIdResponse?.data?.existing_loan ? "Yes": "No"
        }

        if(!requestParams['payment_details']['for_closure_amount']){
            requestParams['payment_details']['for_closure_amount'] = ucdCaseByIdResponse?.data?.fore_closure_amount
        }

        if(!requestParams['payment_details']['fc_closure_amount_proof']){
            requestParams['payment_details']['fc_closure_amount_proof'] = ucdCaseByIdResponse?.data?.fore_closure_amount_proof
        }

        if(!requestParams['payment_details']['prev_loan_closure'] && ucdCaseByIdResponse?.data?.previous_loan_closed_by){
            requestParams['payment_details']['prev_loan_closure'] = ucdCaseByIdResponse?.data?.previous_loan_closed_by ?? ""
        }

        if(!requestParams['payment_details']['mode_of_payment']){
            requestParams['payment_details']['mode_of_payment'] = ucdCaseByIdResponse?.data?.mode_of_payment ?? ""
        }

        if(!requestParams['payment_details']['loan_amount_from_bank']){
            requestParams['payment_details']['loan_amount_from_bank'] = ucdCaseByIdResponse?.data?.loan_amount_received_from_bank
        }

        if(!requestParams['payment_details']['utr_no']){
            requestParams['payment_details']['utr_no'] = ucdCaseByIdResponse?.data?.bank_transfer_utr_number
        }

        if(!requestParams['payment_details']['loan_closure_payment_proof']){
            requestParams['payment_details']['loan_closure_payment_proof'] = ucdCaseByIdResponse?.data?.loan_closure_payment_proof
        }

        if(!requestParams['hold_back_Details']['account_id']){
            requestParams['hold_back_Details']['account_id'] = loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.account_id;
        }

        if(!requestParams['hold_back_Details']['mode_of_payment']){
            requestParams['hold_back_Details']['mode_of_payment'] = loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.payment_mode;
        }

        if(!requestParams['hold_back_Details']['remark']){
            requestParams['hold_back_Details']['remark'] = loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.remark;
        }

        if(!requestParams['hold_back_Details']['amount']){
            requestParams['hold_back_Details']['amount'] = ucdCaseByIdResponse?.data?.hold_back_amount;
        }

        if(!requestParams['hold_back_Details']['amount_approval_proof']){
            requestParams['hold_back_Details']['amount_approval_proof'] = ucdCaseByIdResponse?.data?.hold_back_amount_proof ;
        }

        if(!requestParams['undertaking']['undertaking']){
            requestParams['undertaking']['undertaking'] = ucdCaseByIdResponse?.data?.customer_undertaking ;
        }

        if(parseInt(requestParams['payment_details']['loan_amount_from_bank']) > 2000000 && !requestParams['hold_back_Details']['amount_approval_proof']){
            toast.error("Hold back amount  proof is missing!");
            return false;
        }
        requestParams['tranches'] = tranches;
        requestParams['case_id'] = match?.params?.id;
        setIsLoading(true);
        if(ucdCaseByIdResponse?.data?.loan_amount_received_from_bank){
            console.log("update")
            await loanPaymentRaiseUpdateRequest(requestParams)
        } else {
            console.log("create")
            await loanPaymentRaiseRequest(requestParams)
        }

        setIsLoading(false);
    }


    const handleAddTranches = (e) => {
        e.preventDefault();
        setTranches([
            ...tranches, {amount: '', account_id: '', payment_mode: '', remark: ''}
        ]);
    }

    const handleRemoveTranches = (e, index) => {
        e.preventDefault();
        let list = [...tranches]
        list.splice(index, 1);
        setTranches(list)
    }

    const handleTrancheInput = (val, key, index) => {
        const list = [...tranches]
        list[index][key] = val
        setTranches(list)
    }

    const handleAddAmountReceivedFromBank = () => {
        setBankAmountLoanReceived([
            ...bankAmountLoanReceived, {loan_amount_from_bank: '', utr_no: ''}
        ]);
    }

    const handleRemoveAmountReceivedFromBank = (e, index) => {
        e.preventDefault();
        let list = [...bankAmountLoanReceived]
        list.splice(index, 1);
        setBankAmountLoanReceived(list)
    }

    const handleAmountReceivedFromBankInput = (val, key, index) => {
        const list = [...bankAmountLoanReceived]
        list[index][key] = val
        setBankAmountLoanReceived(list)
    }


    const handleStage = stageNo => {
        let list = [...inputList];
        let isTrue = false;
        let errorMsg = '';

        if(stageNo === 3){
            if(parseInt(inputList[0].hold_back_Details['loan_amount_from_bank']) > 2000000 && !inputList[0]['hold_back_Details']['amount_approval_proof']){
                toast.error("Hold back amount  proof is missing!");
                return false;
            }
        }

        if(stageNo === 3){
            if(parseInt(inputList[0].hold_back_Details['loan_amount_from_bank']) > 1000000
                && (parseInt(inputList[0].hold_back_Details['amount']) > 20000 || parseInt(inputList[0].hold_back_Details['amount']) < 20000)
                && !inputList[0]['hold_back_Details']['amount_approval_proof']){
                toast.error("Hold back amount  proof is missing!");
                return false;
            }
        }

        // if(stageNo === 3){
        //     if(parseInt(inputList[0].hold_back_Details['loan_amount_from_bank']) > 1000000 &&  parseInt(inputList[0].hold_back_Details['loan_amount_from_bank']) < 2000000
        //         && (parseInt(inputList[0].hold_back_Details['amount']) > 40000 || parseInt(inputList[0].hold_back_Details['amount']) < 40000)
        //         && !inputList[0]['hold_back_Details']['amount_approval_proof']){
        //         toast.error("Hold back amount  proof is missing!");
        //         return false;
        //     }
        // }

        if(ucdCaseByIdResponse?.data?.loan_amount_received_from_bank){
            setStage(stageNo)
            return false;
        }


        if (stageNo - 1 === 1) {
            Object.keys(list[0].payment_details).forEach((key) => {
                if (list[0].payment_details['existing_loan'] === 'No') {
                    isTrue = !list[0].payment_details['loan_amount_from_bank'];
                    isTrue = !list[0].payment_details['utr_no'];
                    errorMsg = "Loam amount or utr no is missing!";
                } else {
                    if (!list[0].payment_details[key]) {
                        errorMsg = `${key} is missing!`;
                        isTrue = true;
                    }
                }
                isTrue = !list[0].payment_details['disbursal_date'];
                if(!list[0].payment_details['disbursal_memo']){
                    setCheckDisbursalMemo(true)
                    isTrue = true
                }
            })
        }

        // if (stageNo - 1 === 2) {
        //     Object.keys(list[0].dealer_details).forEach((key) => {
        //         if (!list[0].dealer_details[key]) {
        //             isTrue = true;
        //         }
        //     })
        // }

        if (stageNo - 1 === 3) {
            Object.keys(list[0].hold_back_Details).forEach((key) => {
                if (!list[0].hold_back_Details[key] && key !== 'amount_approval_proof') {
                    isTrue = true;
                }

                if(parseInt(amountReceived) !== parseInt(list[0].hold_back_Details['amount']) && key === 'amount_approval_proof' && !list[0].hold_back_Details[key]){
                    errorMsg = "Document for amount proof is required!";
                    isTrue = true;
                }
            })
        }

        if (stageNo - 1 === 4) {
            console.log(tranches)
            tranches.map(val => {
                console.log(val)
                Object.keys(val).forEach((key) => {
                    if (!val[key]) {
                        isTrue = true;
                        errorMsg = `${key} is missing!`;
                    }
                })
            })
        }

        if(isTrue && errorMsg){
            toast.error(errorMsg)
        }
        isTrue ? setStage(stageNo - 1) : setStage(stageNo);
    }

    // useEffect(() => {
    //     if(loanAccountResponse?.data && loanAccountResponse?.data?.DEALER){
    //         let list = [...inputList];
    //         list['dealer_details'] = {
    //             account_number: loanAccountResponse?.data?.DEALER?.account_number,
    //             bank_name: loanAccountResponse?.data?.DEALER?.bank_name,
    //             ifsc_code: loanAccountResponse?.data?.DEALER?.ifsc_code,
    //             branch_name: loanAccountResponse?.data?.DEALER?.branch_name,
    //         };
    //         setInputList(list)
    //     }
    // }, [loanAccountResponse])

    useEffect(() => {
        if(loanTranchesResponse?.data ){
            let list = [...inputList];

            if(loanTranchesResponse?.data?.HOLD_BACK_TRANCHE){
                list[0]['hold_back_Details']['account_id'] = loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.account_id;
                list[0]['hold_back_Details']['mode_of_payment'] = loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.payment_mode;
                list[0]['hold_back_Details']['remark'] = loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.remark;
                if(loanTranchesResponse?.data?.TRANCHES.length > 0 ){
                    setTranches(loanTranchesResponse?.data?.TRANCHES)
                }
            }

            list[0]['dealer_details'] = {
                account_number: loanAccountResponse?.DEALER?.account_number,
                bank_name: loanAccountResponse?.DEALER?.bank_name,
                ifsc_code: loanAccountResponse?.DEALER?.ifsc_code,
                branch_name: loanAccountResponse?.DEALER?.branch_name,
            };

            if(ucdCaseByIdResponse?.data){
                list[0]['payment_details'] = {
                    existing_loan: ucdCaseByIdResponse?.data?.existing_loan ? "Yes": "No",
                    for_closure_amount: ucdCaseByIdResponse?.data?.fore_closure_amount,
                    // fc_closure_amount_proof: ucdCaseByIdResponse?.data?.fore_closure_amount_proof,
                    mode_of_payment: ucdCaseByIdResponse?.data?.mode_of_payment,
                    loan_amount_from_bank: ucdCaseByIdResponse?.data?.loan_amount_received_from_bank,
                    utr_no: ucdCaseByIdResponse?.data?.branch_name,
                    loan_closure_payment_proof: ucdCaseByIdResponse?.data?.loan_closure_payment_proof,
                    disbursal_memo: ucdCaseByIdResponse?.data?.disbursal_memo,
                    disbursal_date: ucdCaseByIdResponse?.data?.disbursal_date,
                };

                list[0]['hold_back_Details']['amount'] = ucdCaseByIdResponse?.data?.hold_back_amount ?? null;
                list[0]['hold_back_Details']['amount_approval_proof'] = ucdCaseByIdResponse?.data?.hold_back_amount_proof ?? null;

                let amount = 0;
                if(!list[0]['hold_back_Details']['amount']){
                    if(parseInt(ucdCaseByIdResponse?.data?.loan_approved_amount) <= 1000000){
                        amount = 20000;
                    } else if(parseInt(ucdCaseByIdResponse?.data?.loan_approved_amount) > 1000000 && parseInt(ucdCaseByIdResponse?.data?.loan_approved_amount) < 2000000){
                        amount = 40000;
                    }
                    if(amount){
                        handleInput(amount, 'amount','','hold_back_Details');
                    }
                    setAmountReceived(amount);
                }
                setInputList(list)

            }
        }
    }, [loanTranchesResponse, ucdCaseByIdResponse, loanAccountResponse]);


    const handlePaymentRelease = async () => {
        setIsLoading(true)
        await loanApprovalRequestRequest({loan_id: match?.params?.id, status: "REQUEST_FOR_PAYMENT_RELEASE"})
        setIsLoading(false)
    }

    useEffect(() => {
        if(parseInt(loanPaymentRaiseUpdateResponse?.status) === 200){
            toast.success(loanPaymentRaiseUpdateResponse?.message);
            window.location.href=`ucd-case-list/${match?.params?.dealer_id}/${match?.params?.id}`
        } else if(parseInt(loanPaymentRaiseUpdateResponse?.status) !== 200){
            toast.error(loanPaymentRaiseUpdateResponse?.message);
        }
    }, [loanPaymentRaiseUpdateResponse])

    useEffect(() => {
        if(parseInt(loanPaymentRaiseResponse?.status) === 200){
            toast.success(loanPaymentRaiseResponse?.message);
            window.location.href=match?.params?.dealer_id ? `ucd-case-list/${match?.params?.dealer_id}/${match?.params?.id}` : `${baseUrl}/ucd/lead/logged-in`
        } else if(parseInt(loanPaymentRaiseResponse?.status) !== 200){
            toast.error(loanPaymentRaiseResponse?.message);
        }
    }, [loanPaymentRaiseResponse])

    useEffect(() => {
        if(checkDisbursalMemo){
            toast.error("Disbursal memo is missing!");
        }
        setCheckDisbursalMemo(false);
    }, [checkDisbursalMemo]);

    useEffect(() => {
        let amount = 0;
        if(!ucdCaseByIdResponse?.data){
            return ;
        }
        if(parseInt(ucdCaseByIdResponse?.data?.loan_approved_amount) <= 1000000){
            amount = 20000;
        } else if(parseInt(ucdCaseByIdResponse?.data?.loan_approved_amount) > 1000000 && parseInt(ucdCaseByIdResponse?.data?.loan_approved_amount) < 2000000){
            amount = 40000;
        }
        if(amount){
            handleInput(amount, 'amount','','hold_back_Details', );
        }

        setAmountReceived(amount);

    }, [ucdCaseByIdResponse]);


    useEffect(() => {
        if(parseInt(loanApprovalRequestResponse?.status) === 200){
            toast.success(loanApprovalRequestResponse?.message);
            window.location.href=`ucd-case-list/${match?.params?.dealer_id}/${match?.params?.id}`
        } else if(parseInt(loanApprovalRequestResponse?.status) !== 200){
            toast.error(loanApprovalRequestResponse?.message);
        }
    }, [loanApprovalRequestResponse])


    useEffect(() => {
        if(parseInt(loanPaymentRaiseUpdateResponse?.status) === 200){
            toast.success(loanPaymentRaiseUpdateResponse?.message);
            window.location.href = match?.params?.dealer_id ? `ucd-case-list/${match?.params?.dealer_id}/${match?.params?.id}` : `${baseUrl}/ucd/lead/logged-in`
        } else if(parseInt(loanPaymentRaiseUpdateResponse?.status) !== 200){
            toast.error(loanPaymentRaiseUpdateResponse?.message);
        }
    }, [loanPaymentRaiseUpdateResponse])

    useEffect(() => {
        if(parseInt(loanApprovalRequestResponse?.status) === 200){
            toast.success(loanApprovalRequestResponse?.message);
            window.location.href = match?.params?.dealer_id ? `ucd-case-list/${match?.params?.dealer_id}/${match?.params?.id}` : `${baseUrl}/ucd/lead/logged-in`
        } else if(parseInt(loanApprovalRequestResponse?.status) !== 200){
            toast.error(loanApprovalRequestResponse?.message);
        }
    }, [loanApprovalRequestResponse])

    useEffect(() => {
        let amount = 0;
        if(parseInt(amountReceived) <= 1000000){
            amount = 20000;
        } else if(parseInt(amountReceived) > 1000000 && parseInt(amountReceived) < 2000000){
            amount = 40000;
        }
        setAmountChanged(amount)
        if(amount){
            handleInput(amount, 'amount','','hold_back_Details', );
        }

    }, [amountReceived]);

    return (
        <>
            <Layout
                title={"Add New Case"}
                isLoading={isLoading}
                isGoback={true}
            >
                <div className="container-fluid">
                    <div className="container-v2">
                        <link rel="stylesheet"
                              href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.0.3/css/font-awesome.css"/>
                        <div id="msform">
                            <ul id="progressbar">
                                <li id="confirm" className={`${(stage < 2) ? 'active' : 'done'}`}><span
                                    className='pb-v2'><strong>Payment</strong></span></li>
                                <li id="confirm"
                                    className={`${(stage == 2) ? 'active' : (stage > 2) ? 'done' : 'inactive'}`}>
                                    <span className='pb-v2'><strong>Dealer</strong></span></li>
                                <li id="confirm"
                                    className={`${(stage == 3) ? 'active' : (stage > 3) ? 'done' : 'inactive'}`}>
                                    <span className='pb-v2'><strong>Hold Back Amount</strong></span>
                                </li>
                                <li id="confirm"
                                    className={`${(stage == 4) ? 'active' : (stage > 4) ? 'done' : 'inactive'}`}>
                                    <span className='pb-v2'><strong>Tranches</strong></span>
                                </li>
                                <li id="confirm"
                                    className={`${(stage == 5) ? 'active' : (stage > 5) ? 'done' : 'inactive'}`}>
                                    <span className='pb-v2'><strong>Undertaking</strong></span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <form onSubmit={(e) => handleSubmit(e)}>
                        {stage === 1 &&
                            <div className="card">
                                <div className="card-body">
                                <div className="row">
                                        <div className="col-sm-6">
                                            <DropDownInput
                                                label={'Existing Loan'}
                                                data={[{id: "Yes", name: "Yes"}, {
                                                    id: "No",
                                                    name: "No"
                                                }]}
                                                getIdValue={(val) => {
                                                    handleInput(val.id, 'existing_loan', '', 'payment_details')
                                                }}
                                                value={inputList[0]['payment_details']['existing_loan']}
                                                isStarRequired={true}
                                                required={true}
                                            />
                                        </div>
                                        {inputList[0]['payment_details']['existing_loan'] === 'Yes' &&
                                            <>
                                                <div
                                                    className="col-sm-6 float-field mb-3">
                                                <ConstantInput
                                                        label={"Fore Closure Amount"}
                                                        handleChange={(val) =>
                                                            handleInput(val, 'for_closure_amount', '', 'payment_details')
                                                        }
                                                        value={inputList[0]['payment_details']['for_closure_amount']}
                                                        type="number"
                                                        required={true}
                                                        isStarRequired={true}
                                                        decimal={"decimal"}
                                                        step={"any"}
                                                    />
                                                </div>
                                                <div className="col-md-6 col-sm-12">
                                                    <FileUpload
                                                        id={"fc_closure_amount_proof"}
                                                        accept=".pdf,.png,.jpg,.jpeg,.doc"
                                                        documentUploadUrl={documentUploadUrlPublic}
                                                        documentUrlData={documentUrlDataPublic}
                                                        onChange={(val) => handleInput(val, 'fc_closure_amount_proof', '', 'payment_details')}
                                                        prefilledFilename={inputList[0]['payment_details']['fc_closure_amount_proof'] ? "FC Closure Amount Proof" : ""}
                                                        width={"100%"}
                                                    >
                                                <span className="btn btn-transparent"
                                                      style={{minWidth: '100%'}}>FC Closure Amount Proof<div
                                                    style={{color: "red"}}>*</div></span>
                                                    </FileUpload>
                                                </div>
                                                <div
                                                    className="col-sm-6 float-field mb-3">
                                                    <ConstantInput
                                                        label={"Disbursal Date"}
                                                        handleChange={(val) =>
                                                            handleInput(val, 'disbursal_date', '', 'payment_details')
                                                        }
                                                        value={inputList[0]['payment_details']['disbursal_date']}
                                                        type="date"
                                                        required={true}
                                                        isStarRequired={true}
                                                    />
                                                </div>
                                                <div className="col-md-6 col-sm-12">
                                                    <FileUpload
                                                        id={"disbursal_memo"}
                                                        accept=".pdf,.png,.jpg,.jpeg,.doc"
                                                        documentUploadUrl={documentUploadUrlPublic}
                                                        documentUrlData={documentUrlDataPublic}
                                                        onChange={(value) => handleInput(value, 'disbursal_memo', '', 'payment_details')}
                                                        prefilledFilename={inputList[0]['payment_details']['disbursal_memo'] ? "Disbursal Memo" : ""}
                                                        width={"100%"}
                                                    >
                                                    <span className="btn btn-transparent"
                                                          style={{minWidth: '100%'}}>Disbursal Memo<div
                                                        style={{color: "red"}}>*</div>
                                                    </span>
                                                    </FileUpload>
                                                </div>
                                                <div className="col-sm-6">
                                                    <DropDownInput
                                                        label={'Previous Loan Closure By'}
                                                        data={[{id: "Bank", name: "Bank"}, {
                                                            id: "Park+",
                                                            name: "Park+"
                                                        }]}
                                                        getIdValue={(val) => {
                                                            handleInput(val.id, 'prev_loan_closure', '', 'payment_details')
                                                        }}
                                                        value={inputList[0]['payment_details']['prev_loan_closure'] ?? ""}
                                                    />
                                                </div>
                                                <div className="col-sm-6">
                                                    <DropDownInput
                                                        label={'Mode of payment for Loan Closure'}
                                                        data={[{id: "DD", name: "DD"}, {
                                                            id: "RTGS",
                                                            name: "RTGS"
                                                        }, {id: "NEFT", name: "NEFT"}, {id: "Other", name: "Other"}]}
                                                        getIdValue={(val) => {
                                                            handleInput(val.id, 'mode_of_payment', '', 'payment_details')
                                                        }}
                                                        value={inputList[0]['payment_details']['mode_of_payment'] ?? ""}
                                                    />
                                                </div>
                                                <div className="col-md-6 col-sm-12">
                                                    <FileUpload
                                                        id={"loan_closure_payment_proof"}
                                                        accept=".pdf,.png,.jpg,.jpeg,.doc"
                                                        documentUploadUrl={documentUploadUrlPublic}
                                                        documentUrlData={documentUrlDataPublic}
                                                        onChange={(val) => handleInput(val, 'loan_closure_payment_proof', '', 'payment_details')}
                                                        prefilledFilename={
                                                            (inputList[0]['payment_details']['loan_closure_payment_proof'] || ucdCaseByIdResponse?.data?.loan_closure_payment_proof)
                                                                ? "Loan Closure Amount Proof"
                                                                : ""}
                                                        width={"100%"}
                                                    >
                                                <span className="btn btn-transparent"
                                                      style={{minWidth: '100%'}}>Loan Closure Amount Proof<div
                                                    style={{color: "red"}}>*</div></span>
                                                    </FileUpload>
                                                </div>
                                            </>
                                        }
                                        <div
                                            className="col-sm-6 float-field mb-3">
                                            <ConstantInput
                                                label={"Loan Amount Received From Bank"}
                                                handleChange={(val) =>
                                                    handleInput(val, 'loan_amount_from_bank', '', 'payment_details')
                                                }
                                                value={inputList[0]['payment_details']['loan_amount_from_bank']}
                                                type="number"
                                                required={true}
                                                isStarRequired={true}
                                                decimal={'decimal'}
                                                step={'any'}
                                            />
                                        </div>
                                        <div
                                            className="col-sm-6 float-field mb-3">
                                            <ConstantInput
                                                label={"Transaction Proof No"}
                                                handleChange={(val) =>
                                                    handleInput(val, 'utr_no', '', 'payment_details')
                                                }
                                                value={inputList[0]['payment_details']['utr_no']}
                                                type="text"
                                                required={true}
                                                isStarRequired={true}
                                            />
                                        </div>
                                        <div className="col-sm-4">
                                            <ConstantInput
                                                label={"Disbursal Date"}
                                                handleChange={(val) =>
                                                    handleInput(val, 'disbursal_date', '', 'payment_details')
                                                }
                                                value={""}
                                                type="date"
                                                isStarRequired={true}
                                                required={true}
                                                value={inputList[0]['payment_details']['disbursal_date']}
                                            />
                                        </div>
                                        <div className="col-md-3 col-sm-12">
                                            <FileUpload
                                                id={"disbursal_memo"}
                                                accept=".pdf,.png,.jpg,.jpeg,.doc"
                                                documentUploadUrl={documentUploadUrlPublic}
                                                documentUrlData={documentUrlDataPublic}
                                                onChange={(val) => handleInput(val, 'disbursal_memo', '', 'payment_details')}
                                                prefilledFilename={inputList[0]['payment_details']['disbursal_memo'] ? "Disbursal Memo" : ""}
                                                width={"100%"}
                                            >
                                    <span className="btn btn-transparent"
                                          style={{minWidth: '100%'}}>Disbursal Memo <div style={{color:'red'}}>*</div></span>
                                            </FileUpload>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }


                        {stage === 2 &&
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div
                                            className="col-sm-6 float-field mb-3">
                                            <ConstantInput
                                                label={"Account Number"}
                                                handleChange={(val) =>
                                                    handleInput(val, 'account_number', '', 'dealer_details')
                                                }
                                                value={loanAccountResponse?.DEALER?.account_number}
                                                type="text"
                                                required={true}
                                                isStarRequired={true}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="col-sm-6">
                                            <DropDownInput
                                                label={'Bank Name'}
                                                data={bankListResponse}
                                                getIdValue={(val) => {
                                                    handleInput(val.id, 'bank_name', '', 'dealer_details')
                                                }}
                                                value={loanAccountResponse?.DEALER?.bank_name}
                                                isStarRequired={true}
                                                disabled={true}
                                            />
                                        </div>
                                        <div
                                            className="col-sm-6 float-field mb-3">
                                            <ConstantInput
                                                label={"IFSC Code"}
                                                handleChange={(val) =>
                                                    handleInput(val, 'ifsc_code', '', 'dealer_details')
                                                }
                                                value={loanAccountResponse?.DEALER?.ifsc_code}
                                                type="text"
                                                required={true}
                                                isStarRequired={true}
                                                disabled={true}
                                            />
                                        </div>
                                        <div
                                            className="col-sm-6 float-field mb-3">
                                            <ConstantInput
                                                label={"Branch Name"}
                                                handleChange={(val) =>
                                                    handleInput(val, 'branch_name', '', 'dealer_details')
                                                }
                                                value={loanAccountResponse?.DEALER?.branch_name}
                                                type="text"
                                                required={true}
                                                isStarRequired={true}
                                                disabled={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                        {stage === 3 &&
                            <>
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-sm-6 float-field mb-3">
                                                <ConstantInput
                                                    label={"Hold Back Amount"}
                                                    handleChange={(val) =>
                                                        handleInput(val, 'amount', '', 'hold_back_Details')
                                                    }
                                                    value={inputList[0]['hold_back_Details']['amount']}
                                                    type="number"
                                                    required={true}
                                                    isStarRequired={true}
                                                    decimal={'decimal'}
                                                    step={'any'}
                                                />
                                            </div>
                                            <div className="col-md-6 col-sm-12">
                                                <FileUpload
                                                    id={"amount_approval_proof"}
                                                    accept=".pdf,.png,.jpg,.jpeg,.doc"
                                                    documentUploadUrl={documentUploadUrlPublic}
                                                    documentUrlData={documentUrlDataPublic}
                                                    onChange={(val) => handleInput(val, 'amount_approval_proof', '', 'hold_back_Details')}
                                                    prefilledFilename={(inputList[0]['hold_back_Details']['amount_approval_proof'] || ucdCaseByIdResponse?.data?.hold_back_amount_proof)
                                                        ?
                                                        "Hold Back Amount Approval" : ""}
                                                    width={"100%"}
                                                >
                                                <span className="btn btn-transparent"
                                                      style={{minWidth: '100%'}}>Approval
                                                    {(parseInt(inputList[0]['hold_back_Details']['amount']) !== parseInt(changeAmount)) ?
                                                        <div
                                                            style={{color: "red"}}>*</div> : ""}</span>
                                                </FileUpload>
                                            </div>
                                            <div className="container-fluid">
                                                <div className="card">
                                                    <div
                                                        className="card-header">{"Hold Back Amount Release Tranches"}</div>
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-sm-6">
                                                                <DropDownInput
                                                                    label={'Account'}
                                                                    data={loanAccountResponse?.accounts}
                                                                    getIdValue={(val) => {
                                                                        handleInput(val.id, 'account_id', '', 'hold_back_Details')
                                                                    }}
                                                                    value={inputList[0]['hold_back_Details']['account_number']}
                                                                    isStarRequired={true}
                                                                    required={true}
                                                                />
                                                            </div>
                                                            <div className="col-sm-6">
                                                                <DropDownInput
                                                                    label={'Mode of payment'}
                                                                    data={[
                                                                        {id: "DD", name: "DD"},
                                                                        {id: "RTGS", name: "RTGS"},
                                                                        {id: "NEFT", name: "NEFT"},
                                                                        {id: "Other", name: "Other"}
                                                                    ]}
                                                                    getIdValue={(val) => {
                                                                        handleInput(val.id, 'mode_of_payment', '', 'hold_back_Details')
                                                                    }}
                                                                    value={inputList[0]['hold_back_Details']['mode_of_payment'] ?? ""}
                                                                    required={true}
                                                                    isStarRequired={true}
                                                                />
                                                            </div>
                                                            <div className="col-sm-6 float-field mb-3">
                                                                <ConstantInput
                                                                    label={"Remark"}
                                                                    handleChange={(val) =>
                                                                        handleInput(val, 'remark', '', 'hold_back_Details')
                                                                    }
                                                                    value={inputList[0]['hold_back_Details']['remark']}
                                                                    type="text"
                                                                    required={true}
                                                                    isStarRequired={true}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </>
                        }
                        {stage === 4 &&
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        {tranches.map((val, i) => {
                                            return (
                                                <div key={i} className="row">
                                                    <div className="col-sm-6 float-field mb-3">
                                                        <ConstantInput
                                                            label={"Tranche Amount"}
                                                            handleChange={(val) =>
                                                                handleTrancheInput(val, 'amount', i)
                                                            }
                                                            value={val?.amount}
                                                            type="number"
                                                            required={true}
                                                            isStarRequired={true}
                                                            decimal={'decimal'}
                                                            step={'any'}
                                                        />
                                                    </div>
                                                    <div className="col-sm-6">
                                                        <DropDownInput
                                                            label={'Account'}
                                                            data={loanAccountResponse?.accounts}
                                                            getIdValue={(val) => {
                                                                handleTrancheInput(val.id, 'account_id', i)
                                                            }}
                                                            value={val?.id}
                                                            required={true}
                                                            isStarRequired={true}
                                                        />
                                                    </div>
                                                    <div className="col-sm-6">
                                                        <DropDownInput
                                                            label={'Mode of payment'}
                                                            data={[{id: "DD", name: "DD"}, {
                                                                id: "RTGS",
                                                                name: "RTGS"
                                                            }, {id: "NEFT", name: "NEFT"}, {
                                                                id: "Other",
                                                                name: "Other"
                                                            }]}
                                                            getIdValue={(val) => {
                                                                handleTrancheInput(val.id, 'payment_mode', i)
                                                            }}
                                                            value={val?.payment_mode}
                                                            required={true}
                                                            isStarRequired={true}
                                                        />
                                                    </div>
                                                    <div className="col-sm-6 float-field mb-3">
                                                        <ConstantInput
                                                            label={"Remark"}
                                                            handleChange={(val) =>
                                                                handleTrancheInput(val, 'remark', i)
                                                            }
                                                            value={val?.remark}
                                                            type="text"
                                                            required={true}
                                                            isStarRequired={true}
                                                        />
                                                    </div>
                                                    <div className="btn-box mb-4" style={{width: "100%"}}>
                                                        {tranches.length !== 1 && (
                                                            <button
                                                                onClick={(e) => handleRemoveTranches(e, i)}
                                                                className="btn btn-sm btn-danger ml-3">
                                                                - Remove Tranche
                                                            </button>
                                                        )}
                                                        {tranches.length - 1 === i && (
                                                            <button
                                                                className="btn btn-sm btn-primary ml-3 mt-3"
                                                                onClick={(e) => handleAddTranches(e)}>
                                                                + Add Another Tranche
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        }

                        {stage === 5 &&
                            <>
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-12 col-sm-12">
                                                <FileUpload
                                                    id={"Undertaking"}
                                                    accept=".pdf,.png,.jpg,.jpeg,.doc"
                                                    documentUploadUrl={documentUploadUrlPublic}
                                                    documentUrlData={documentUrlDataPublic}
                                                    onChange={(val) => handleInput(val, 'undertaking', '', 'undertaking')}
                                                    prefilledFilename={(inputList[0]['undertaking']['undertaking'] ||
                                                        ucdCaseByIdResponse?.data?.customer_undertaking) ? "Undertaking" : ""}
                                                    width={"100%"}
                                                >
                                                <span className="btn btn-transparent"
                                                      style={{minWidth: '100%'}}>Undertaking</span>
                                                </FileUpload>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </>
                        }
                        <div className="d-flex" >
                            {parseInt(stage) > 1 &&
                                <div className="col-md-6">
                                    <button
                                        className="btn btn-primary btn-user btn-block submit-btn"
                                        onClick={() => {
                                            handleStage(stage - 1)
                                        }}>
                                        Go Back
                                    </button>
                                </div>
                            }

                            {parseInt(stage) <= 4 &&
                                <div className="col-md-6">
                                    <button
                                        className="btn btn-primary btn-user btn-block submit-btn"
                                        onClick={() => {
                                            handleStage(stage + 1)
                                        }}>
                                        Next
                                    </button>
                                </div>
                            }

                            {parseInt(stage) === 5 &&
                                <div className="col-md-6">
                                    <button
                                        className="btn btn-primary btn-user btn-block submit-btn"
                                    >
                                        Submit
                                    </button>
                                </div>
                            }
                            {ucdCaseByIdResponse?.data?.loan_amount_received_from_bank &&
                                <div className="col-md-6 mt-4">
                                    <button
                                        className="btn btn-primary btn-user btn-block submit-btn"
                                        onClick={handlePaymentRelease}
                                    >
                                        Request For Payment Release
                                    </button>
                                </div>
                            }
                        </div>
                    </form>

                    {ucdCaseByIdResponse?.data?.loan_amount_received_from_bank &&
                        <div className="col-md-6 mt-4">
                            <button
                                className="btn btn-primary btn-user btn-block submit-btn"
                                onClick={handlePaymentRelease}
                            >
                                Request For Payment Release
                            </button>
                        </div>
                    }

                </div>


            </Layout>
        </>
    );
};

export default PaymentRaise;
